import { useMemo } from 'react';
import { WarehouseProps } from 'componentsV2/product/details/content/subpages';
import InfoIcon from '@material-ui/icons/Info';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ProductsEmptyState } from 'componentsV2/product/details/content/components';
import { SInfiniteTable } from '@setvi/shared/components';
import { useWarehouseColumns } from 'componentsV2/product/details/content/subpages/warehouse/useWarehouseColumns';
import { ProductDetailsColumnsIds } from '@setvi/shared/interfaces';
import { TabContentWrapper } from '../styled';

// For the Mobile Warehouse we need only Location and Stock columns
const mobileWarehouseColumns = [
  ProductDetailsColumnsIds.Location,
  ProductDetailsColumnsIds.Stock
];

export const MobileWarehouse = ({
  configColumns = [],
  product,
  selectedCustomer
}: WarehouseProps) => {
  const mobileFilteredColumns = configColumns.filter(({ id }) =>
    mobileWarehouseColumns.includes(id as ProductDetailsColumnsIds)
  );

  const { warehouseColumns } = useWarehouseColumns({
    selectedCustomer,
    configColumns: mobileFilteredColumns
  });

  const content = useMemo(() => {
    if (product?.dropship)
      return (
        <Box mt={3}>
          <Alert severity="info" icon={<InfoIcon />}>
            This item is Dropshipped. It will be directly shipped to the
            customer. Stock availability may not be available for dropshipped
            items.
          </Alert>
        </Box>
      );

    if (product?.inventory?.length === 0)
      return (
        <Box flex={1} display="flex">
          <ProductsEmptyState title="No Inventory Available" />
        </Box>
      );

    return (
      <Box flex={1} overflow="auto">
        <SInfiniteTable
          newDesign
          list={product.inventory}
          columns={warehouseColumns}
          keyGetter={i => i._id}
        />
      </Box>
    );
  }, [product?.dropship, product.inventory, warehouseColumns]);

  return <TabContentWrapper>{content}</TabContentWrapper>;
};
